import ProgressCaption from '@frontend/jetlend-web-ui/src/ui/ProgressCaption/ProgressCaption';
import { useState } from 'react';
import { useOptionalInterval } from '@frontend/jetlend-core/src/hooks/useInterval';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import ContentTransitionWrapper from '@frontend/jetlend-web-ui/src/components/ContentTransitionWrapper/ContentTransitionWrapper';
import Loader from '@frontend/jetlend-web-ui/src/ui/loaders/Loader';
import styles from './ScoringLoader.module.scss';

export interface IProps {
    /**
     * Текст заголовка
     */
    title?: string;
}

export interface ProgressItem {
    /**
     * Текст заголовка
     */
    title: string;
    /**
     * Процент выполнения
     */
    from: number;
}

const progressItemsConfiguration: ProgressItem[] = [
    {
        title: 'Анализ данных ФНС',
        from: 0.25,
    },
    {
        title: 'Анализ данных Ресурс БФО',
        from: 0.5,
    },
    {
        title: 'Анализ данных Контур.Фокус',
        from: 0.75,
    },
    {
        title: 'Анализ данных ЕГР',
        from: 1,
    },
];

function calculateLoading(currentProgress: number, breakpoint: number) {
    return (currentProgress * 0.01) < breakpoint;
}

// Длительность лоадера со спиннером перед отображением лоадера с процессом скоринга
const LOADER_DURATION = 5;

/**
 * Компонент отображает прогресс расчета лимита
 */
export default function ScoringLoader({
    title,
}: IProps) {
    const [ progress, setProgress ] = useState(0);
    const isScoringOverdue = progress > 98.5;

    useOptionalInterval(() => {
        const newProgress = Math.min(progress + 1, 99);
        if (Math.abs(newProgress - progress) !== 0) {
            setProgress(newProgress);
        }
    }, !isScoringOverdue, 1000, [ progress ]);

    const showLoader = calculateLoading(progress, LOADER_DURATION * 0.01);

    return (
        <div className={styles['content']}>
            {title && (
                <h2 className={styles['title']} data-testid="limit-prescoring-modal__title">
                    {title}
                </h2>
            )}

            <ContentTransitionWrapper
                transitionKey={showLoader}
                className={styles['transition-wrapper']}
            >
                {showLoader
                    ? (
                        <Loader
                            size='large'
                        />
                    )
                    : (
                        <div className={styles['progress-wrapper']}>
                            {progressItemsConfiguration.map((item, index, array) => {
                                const isLoading = calculateLoading(progress, item.from);
                                const isPrevLoading = index > 0 ? calculateLoading(progress, array[index - 1].from) : false;

                                return (
                                    <ProgressCaption
                                        containerClassName={buildClassNames(styles, ['progress-element', !isPrevLoading && 'progress-element--visible' ])}
                                        className={styles['progress-text']}
                                        key={item.title}
                                        title={item.title}
                                        loading={isLoading}
                                        completed
                                        bordered
                                        iconsType={3}
                                    />
                                );
                            })}
                        </div>
                    )
                }
            </ContentTransitionWrapper>
        </div>
    );
}